/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

import { fetchGraphQl } from '@/quote-management/api/';
import { CUSTOMER_QUERY } from './graphql/CustomerQuery';
import { transformCustomer } from '@/quote-management/data/transforms';
import { state } from '@/quote-management/lib/state';

export const getCustomerData = async () => { 
    if (!state.authenticated) {
        return Promise.reject(new Error('Unauthorized'));
    }

    try {
        const results: any = await fetchGraphQl(CUSTOMER_QUERY);
        
        if (!results?.data?.customer) {
            throw new Error('No customer data received');
        }
        
        return transformCustomer(results.data.customer);
    } catch (error) {
        return Promise.reject(error);
    }
}
